module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-sharp.woff2?4f203ef2d5bc0198ed17648f0642ff96";